export default "__VITE_ASSET__D2ZoUA7u__"